import type { HeaderNotificationItem } from './notification-types';

/** Keep a contiguous, bounded prefix so offset pagination cannot skip new items. */
export function mergeNotificationRefresh(
  previous: HeaderNotificationItem[],
  incoming: HeaderNotificationItem[],
  loadedPage: number,
  pageSize: number,
  total: number
) {
  if (total === 0) return { items: [], page: 1 };

  const previousIds = new Set(previous.map(item => item.id));
  const incomingIds = new Set(incoming.map(item => item.id));
  const hasOverlap = incoming.some(item => previousIds.has(item.id));

  // If a full page arrived without overlap, more than one page may have been
  // inserted. Restart at page one rather than skip the gap with an old offset.
  if (!hasOverlap || incoming.length < pageSize) {
    return { items: incoming, page: 1 };
  }

  const page = Math.max(1, loadedPage);

  return {
    items: [
      ...incoming,
      ...previous.filter(item => !incomingIds.has(item.id)),
    ].slice(0, page * pageSize),
    page,
  };
}
